export const qs = (selector, scope = document) => scope.querySelector(selector);

export const qsa = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));

/** Runs at most once per animation frame — for scroll and resize handlers. */
export const rafThrottle = (fn) => {
  let ticking = false;

  return (...args) => {
    if (ticking) {
      return;
    }

    ticking = true;
    requestAnimationFrame(() => {
      fn(...args);
      ticking = false;
    });
  };
};

export const prefersReducedMotion = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;
